<template>
  <div>
    <div class="ml-3 mr-3 mb-3">
      <div
        style="display: grid; grid-template-columns: repeat(10, 1fr); grid-gap: 0.5rem; width: 1200px;"
      >
        <b-form-group label="Number">
          <b-form-input v-model="copy.number"></b-form-input>
        </b-form-group>

        <b-form-group label="Name *" style="grid-column: 2/5">
          <b-form-input
            :state="$v.copy.name.$error ? $v.copy.name.required : null"
            v-model="copy.name"
            aria-required="10px"
          ></b-form-input>
        </b-form-group>

        <b-form-checkbox
          class="d-flex align-items-center"
          style="grid-column: 5/7"
          v-model="copy.isPrimary"
        >Primary Location</b-form-checkbox>

        <b-form-checkbox
          checked
          class="d-flex align-items-center"
          style="grid-column: 7"
          v-model="copy.active"
          v-if="showActive"
        >Active</b-form-checkbox>
      </div>
    </div>
    <div class="d-flex mb-3">
      <!-- PHYSICAL ADDRESS -->
      <!-- LEFT CONTAINER -->
      <div
        class="ml-3 mr-3"
        style="display: grid; grid-template-columns: repeat(4, 1fr); grid-template-rows: repeat(7, 40px); grid-gap: 0.5rem; width: 1200px;"
      >
        <b-form-group label="Physical Address" style="font-size: large; grid-column: 1/3"></b-form-group>
        <b-form-group label="Address 1 *" style="grid-column: 1/6">
          <b-form-input
            :state="$v.addressObj.physicalAddress1.$error ? $v.addressObj.physicalAddress1.required : null"
            v-model="addressObj.physicalAddress1"
          ></b-form-input>
        </b-form-group>

        <b-form-group label="Address 2" style="grid-column: 1/6">
          <b-form-input v-model="addressObj.physicalAddress2"></b-form-input>
        </b-form-group>
        <b-form-group label="City *" style="grid-column: 1/3">
          <b-form-input
            :state="$v.addressObj.physicalCity.$error ? $v.addressObj.physicalCity.required : null"
            v-model="addressObj.physicalCity"
          ></b-form-input>
        </b-form-group>
        <!-- State -->
        <b-form-group label="State *" style="grid-column: 3/4">
          <b-form-select
            :state="$v.addressObj.physicalState.$error ? $v.addressObj.physicalState.required : null"
            v-model="addressObj.physicalState"
          >
            <template v-slot:first>
              <option :value="null" disabled>-- Select state --</option>
            </template>
            <option v-for="state in states" :key="state.abbr" :value="state.abbr">{{ state.name }}</option>
          </b-form-select>
        </b-form-group>

        <b-form-group label="Zip Code *" style="grid-column: 4/6">
          <b-form-input
            v-mask="'#####-####'"
            placeholder="#####-####"
            :state="$v.addressObj.physicalZipcode.$error ? !$v.addressObj.physicalZipcode.$error : null"
            v-model="addressObj.physicalZipcode"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Email" style="grid-column: 1/6">
          <b-form-input
            :state="$v.copy.email.$error ? $v.copy.email.email : null"
            v-model="copy.email"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Phone" style="grid-column: 1/3">
          <b-form-input
            v-mask="'(###)###-####'"
            :state="$v.copy.phone.$error ? $v.copy.phone.isValidPhone : null"
            v-model="copy.phone"
            placeholder="(###)###-####"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Fax" style="grid-column: 3/6">
          <b-form-input
            :state="$v.copy.fax.$error ? $v.copy.fax.isValidFax : null"
            v-mask="'(###) ###-####'"
            placeholder="(###)###-####"
            v-model="copy.fax"
          ></b-form-input>
        </b-form-group>
      </div>

      <!-- MAILING ADDRESS -->
      <!-- MIDDLE CONTAINER -->

      <div
        class="ml-3 mr-3"
        style="display: grid; grid-template-columns: repeat(4, 1fr); grid-template-rows: repeat(7, 40px); grid-gap: 0.5rem; width: 1200px;"
      >
        <b-form-group label="Mailing Address" style="font-size: large; grid-column: 1/3"></b-form-group>
        <b-form-checkbox
          class="d-flex align-items-center"
          style="grid-column: 3/6"
          v-model="isSameMailing"
        >Same As Physical Address</b-form-checkbox>

        <b-form-group label="Address 1" style="grid-column: 1/6">
          <b-form-input v-model="copy.mailingAddress1" :disabled="isSameMailing"></b-form-input>
        </b-form-group>

        <b-form-group label="Address 2" style="grid-column: 1/6">
          <b-form-input v-model="copy.mailingAddress2" :disabled="isSameMailing"></b-form-input>
        </b-form-group>
        <b-form-group label="City" style="grid-column: 1/3">
          <b-form-input v-model="copy.mailingCity" :disabled="isSameMailing"></b-form-input>
        </b-form-group>
        <!-- State -->
        <b-form-group label="State" style="grid-column: 3/4">
          <state-selector
            :stateId="copy.mailingState"
            @onChange="onMailingStateChange"
            :disabled="isSameMailing"
          ></state-selector>
        </b-form-group>

        <b-form-group label="Zip Code" style="grid-column: 4/6">
          <b-form-input
            v-mask="'#####-####'"
            placeholder="#####-####"
            :state="$v.copy.mailingZipcode.$error ? $v.copy.mailingZipcode.isValidZipcode : null"
            v-model="copy.mailingZipcode"
            :disabled="isSameMailing"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Email" style="grid-column: 1/6">
          <b-form-input
            :state="$v.copy.mailingEmail.$error ? $v.copy.mailingEmail.email : null"
            v-model="copy.mailingEmail"
            :disabled="isSameMailing"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Phone" style="grid-column: 1/3">
          <b-form-input
            :state="$v.copy.mailingPhone.$error ? $v.copy.mailingPhone.isValidPhone : null"
            v-model="copy.mailingPhone"
            v-mask="'(###)###-####'"
            placeholder="(###)###-####"
            :disabled="isSameMailing"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Fax" style="grid-column: 3/6">
          <b-form-input
            v-mask="'(###) ###-####'"
            placeholder="(###)###-####"
            v-model="copy.mailingFax"
            :disabled="isSameMailing"
            :state="$v.copy.mailingFax.$error ? $v.copy.mailingFax.isValidFax : null"
          ></b-form-input>
        </b-form-group>
      </div>

      <!-- SHIPPING ADDRESS -->
      <!-- RIGHT CONTAINER -->

      <div
        class="ml-3 mr-3"
        style="display: grid; grid-template-columns: repeat(4, 1fr); grid-template-rows: repeat(7, 40px); grid-gap: 0.5rem; width: 1200px;"
      >
        <b-form-group label="Shipping Address" style="font-size: large; grid-column: 1/3"></b-form-group>
        <b-form-checkbox
          class="d-flex align-items-center"
          style="grid-column: 3/6"
          v-model="isSameShipping"
        >Same As Physical Address</b-form-checkbox>

        <b-form-group label="Address 1" style="grid-column: 1/6">
          <b-form-input v-model="copy.shippingAddress1" :disabled="isSameShipping"></b-form-input>
        </b-form-group>

        <b-form-group label="Address 2" style="grid-column: 1/6">
          <b-form-input v-model="copy.shippingAddress2" :disabled="isSameShipping"></b-form-input>
        </b-form-group>
        <b-form-group label="City" style="grid-column: 1/3">
          <b-form-input v-model="copy.shippingCity" :disabled="isSameShipping"></b-form-input>
        </b-form-group>
        <!-- State -->
        <b-form-group label="State" style="grid-column: 3/4">
          <state-selector
            :stateId="copy.shippingState"
            @onChange="onShippingStateChange"
            :disabled="isSameShipping"
          ></state-selector>
        </b-form-group>

        <b-form-group label="Zip Code" style="grid-column: 4/6">
          <b-form-input
            v-mask="'#####-####'"
            placeholder="#####-####"
            :state="$v.copy.shippingZipcode.$error ? $v.copy.shippingZipcode.isValidZipcode : null"
            v-model="copy.shippingZipcode"
            :disabled="isSameShipping"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Email" style="grid-column: 1/6">
          <b-form-input
            :state="$v.copy.shippingEmail.$error ? $v.copy.shippingEmail.email : null"
            v-model="copy.shippingEmail"
            :disabled="isSameShipping"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Phone" style="grid-column: 1/3">
          <b-form-input
            :state="$v.copy.shippingPhone.$error ? $v.copy.shippingPhone.isValidPhone : null"
            v-model="copy.shippingPhone"
            v-mask="'(###)###-####'"
            placeholder="(###)###-####"
            :disabled="isSameShipping"
          ></b-form-input>
        </b-form-group>
        <b-form-group label="Fax" style="grid-column: 3/6">
          <b-form-input
            v-mask="'(###) ###-####'"
            placeholder="(###)###-####"
            v-model="copy.shippingFax"
            :disabled="isSameShipping"
            :state="$v.copy.shippingFax.$error ? $v.copy.shippingFax.isValidFax : null"
          ></b-form-input>
        </b-form-group>
      </div>
    </div>
    <div class="ml-3 mr-3 mb-3">
      <div
        style="display: grid; grid-template-columns: repeat(10, 1fr); grid-gap: 0.5rem; width: 1200px;"
      >
        <b-form-group label="Accounts Receivable" style="grid-column: 1/3">
          <b-form-select
            v-model="copy.accountsReceivableUserId"
            :options="contactsOptions"
            @change="onSelectContact('ar', $event)"
          ></b-form-select>
        </b-form-group>
        <b-form-group label="Accounts Payable" style="grid-column: 3/5">
          <b-form-select
            v-model="copy.accountsPayableUserId"
            :options="contactsOptions"
            @change="onSelectContact('ap', $event)"
          ></b-form-select>
        </b-form-group>
        <b-form-group label="Legal" style="grid-column: 5/7">
          <b-form-select
            v-model="copy.legalUserId"
            :options="contactsOptions"
            @change="onSelectContact('legal', $event)"
          ></b-form-select>
        </b-form-group>
        <b-form-group label="IT - Information Technology" style="grid-column: 7/9">
          <b-form-select
            v-model="copy.informationTechnologyUserId"
            :options="contactsOptions"
            @change="onSelectContact('it', $event)"
          ></b-form-select>
        </b-form-group>
        <b-form-group label="HR - Human Resources" style="grid-column: 9/12">
          <b-form-select
            v-model="copy.humanResourcesUserId"
            :options="contactsOptions"
            @change="onSelectContact('hr', $event)"
          ></b-form-select>
        </b-form-group>
      </div>
    </div>
    <div class="ml-3 mr-3 mb-3">
      <div
        style="display: grid; grid-template-columns: repeat(10, 1fr); grid-gap: 0.5rem; width: 1200px;"
      >
        <b-form-group label="Notes" style="grid-column: 1/7">
          <b-form-textarea v-model="copy.notes"></b-form-textarea>
        </b-form-group>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState, mapActions, mapGetters } from 'vuex';
import Grid from '@/shared/components/Grid';
import { SEARCH_DEBOUNCE_TIME, REGEX } from '@/shared/constants';
import StateSelector from '@/shared/components/StateSelector';
import { required, email } from 'vuelidate/lib/validators';
import { STATES } from '@/shared/constants';

//?pageNumber=1&pageSize=10&sortBy=id&sortOrder=ASC&filters={'statusId':null,'dateFrom':null,'dateTo':null}
export default {
  components: {
    Grid,
    StateSelector
  },
  props: ['companyId', 'company', 'updateCompanyLocation'],
  data() {
    return {
      copy: {},
      primaryContact: [],
      checkedRowItemIds: [],
      spObj: {},
      isSameShipping: false,
      isSameMailing: false,
      addressObj: {
        physicalAddress1: null,
        physicalAddress2: null,
        physicalCity: null,
        physicalState: null,
        physicalZipcode: null
      },
      contactsOptions: [],
      states: STATES
    };
  },
  watch: {
    updateCompanyLocation(val) {
      // copy is copied from the incoming company object
      // then we assign it back to an empty vwDto object overwriting
      // any values with those found in the copy after modification in the form
      this.copyPhysicalAddress();
      const nObj = Object.assign({}, this.spObj, this.copy);
      this.spObj = nObj;
      console.log(this.spObj, 'Saving');
      this.spObj.companyId = this.companyId;
      this.spObj.active = this.showActive ? this.copy.active : true;
      this.spObj.isMailingSame = this.isSameMailing;
      this.spObj.isShippingSame = this.isSameShipping;
      this.saveCompanyLocationRecord(this.spObj);
    },
    isSameShipping: function(val) {
      this.copy.isShippingSame = val;

      if (val) {
        this.copyShippingAddress();
      }
    },
    isSameMailing: function(val) {
      this.copy.isMailingSame = val;

      if (val) {
        this.copyMailingAddress();
      }
    },
    addressObj: {
      deep: true,

      handler() {
        if (this.isSameMailing) {
          this.copyMailingAddress();
        }
        if (this.isSameShipping) {
          this.copyShippingAddress();
        }
      }
    }
  },
  computed: {
    ...mapState('contacts', ['contacts']),

    showActive() {
      // Only shows the Active checkbox if on Update form
      return Object.keys(this.company).length > 0;
    }
  },
  methods: {
    //...mapMutations()
    ...mapActions('companies', [
      'getCompanies',
      'getCompanyRoles',
      'getCompanyAttributes',
      'getCompanyStatusValues',
      'getParentCompanies',
      'getCompanyChannels',
      'getSubmittedBy',
      'getLocations',
      'get',
      'sortGrid',
      'getPage',
      'search',
      'clearFilters',
      'saveCompanyLocationRecord'
    ]),

    setFormValues() {
      this.copy = this.company;

      // To Update Records
      if (Object.keys(this.company).length > 0) {
        this.addressObj.physicalAddress1 = this.company.physicalAddress1;
        this.addressObj.physicalAddress2 = this.company.physicalAddress2;
        this.addressObj.physicalCity = this.company.physicalCity;
        this.addressObj.physicalState = this.company.physicalState;
        this.addressObj.physicalZipcode = this.company.physicalZipcode;
        this.isSameMailing = this.company.isMailingSame;
        this.isSameShipping = this.company.isShippingSame;
      } else {
        this.copy.physicalState = null;
      }
    },

    onPhysicalStateChange(val) {
      this.addressObj.physicalState = val.abbr;
    },

    onMailingStateChange(val) {
      this.copy.mailingState = val.abbr;
    },

    onShippingStateChange(val) {
      this.copy.shippingState = val.abbr;
    },

    copyPhysicalAddress() {
      this.copy.physicalAddress1 = this.addressObj.physicalAddress1;
      this.copy.physicalAddress2 = this.addressObj.physicalAddress2;
      this.copy.physicalCity = this.addressObj.physicalCity;
      this.copy.physicalState = this.addressObj.physicalState;
      this.copy.physicalZipcode = this.addressObj.physicalZipcode;
    },

    copyMailingAddress() {
      this.copy.mailingAddress1 = this.addressObj.physicalAddress1;
      this.copy.mailingAddress2 = this.addressObj.physicalAddress2;
      this.copy.mailingCity = this.addressObj.physicalCity;
      this.copy.mailingState = this.addressObj.physicalState;
      this.copy.mailingZipcode = this.addressObj.physicalZipcode;
    },

    copyShippingAddress() {
      this.copy.shippingAddress1 = this.addressObj.physicalAddress1;
      this.copy.shippingAddress2 = this.addressObj.physicalAddress2;
      this.copy.shippingCity = this.addressObj.physicalCity;
      this.copy.shippingState = this.addressObj.physicalState;
      this.copy.shippingZipcode = this.addressObj.physicalZipcode;
    },

    convertToFormSelectObj(arr, { value, firstName, lastName }) {
      let convertedObjArr = [];

      arr.forEach(a => {
        if (this.isValidName(a[firstName]) || this.isValidName(a[lastName])) {
          let name = a[firstName] + ' ' + a[lastName];
          convertedObjArr.push({ value: a[value], text: name });
        }
      });

      return convertedObjArr;
    },

    isValidName(name) {
      return !_.isEmpty(name) && !_.isNull(name) && name != ' ';
    },

    onSelectContact(field, id) {
      let contact = this.contactsOptions.find(contact => contact.value === id);

      switch (field) {
        case 'ar':
          this.copy.arContactName = contact.text;
          this.copy.accountsReceivableUserId = contact.value;
          break;
        case 'ap':
          this.copy.apContactName = contact.text;
          this.copy.accountsPayableUserId = contact.value;
          break;
        case 'legal':
          this.copy.legalContactName = contact.text;
          this.copy.legalUserId = contact.value;
          break;
        case 'it':
          this.copy.itContactName = contact.text;
          this.copy.informationTechnologyUserId = contact.value;
          break;
        case 'hr':
          this.copy.hrContactName = contact.text;
          this.copy.humanResourcesUserId = contact.value;
          break;
      }
    },
    checkPhoneValidity(phone) {
      if (!phone) {
        return true;
      }
      return REGEX.isPhone.test(phone);
    },
    checkFaxValidity(fax) {
      if (!fax) {
        return true;
      }
      return REGEX.isFax.test(fax);
    },
    checkZipcodeValidity(zipcode) {
      if (!zipcode) {
        return true;
      }
      return zipcode.length >= 5;
    }
  },
  validations() {
    return {
      copy: {
        name: { required },
        email: { email },
        phone: {
          isValidPhone(phone) {
            return this.checkPhoneValidity(phone);
          }
        },
        mailingEmail: { email },
        mailingPhone: {
          isValidPhone(mailingPhone) {
            return this.checkPhoneValidity(mailingPhone);
          }
        },
        shippingEmail: { email },
        shippingPhone: {
          isValidPhone(shippingPhone) {
            return this.checkPhoneValidity(shippingPhone);
          }
        },
        mailingFax: {
          isValidFax(mailingFax) {
            return this.checkFaxValidity(mailingFax);
          }
        },
        shippingFax: {
          isValidFax(shippingFax) {
            return this.checkFaxValidity(shippingFax);
          }
        },
        fax: {
          isValidFax(fax) {
            return this.checkFaxValidity(fax);
          }
        },

        shippingZipcode: {
          isValidZipcode(shippingZipcode) {
            return this.checkZipcodeValidity(shippingZipcode);
          }
        },
        mailingZipcode: {
          isValidZipcode(mailingZipcode) {
            return this.checkZipcodeValidity(mailingZipcode);
          }
        }
      },
      addressObj: {
        physicalAddress1: { required },
        physicalCity: { required },
        physicalZipcode: {
          required,
          isValidZipcode(physicalZipcode) {
            return this.checkZipcodeValidity(physicalZipcode);
          }
        },
        physicalState: { required }
      }
    };
  },
  async created() {
    await this.setFormValues();
    this.contactsOptions = this.convertToFormSelectObj(this.contacts, {
      value: 'aspNetUserId',
      firstName: 'firstName',
      lastName: 'lastName'
    });
  }
};
</script>

<style scoped>
.form-width-default {
  width: 200px;
}

.form-width-small {
  width: 70px;
}
</style>